module.exports = __webpack_public_path__ + "static/media/171.da08f3a8.wav";